module.exports = __webpack_public_path__ + "static/phoenix_rising-fdff3dc89eb03be259630f6a3647dd14.jpg";